






























































import Vue, { PropType } from 'vue';
import { IFieldErrors, PaymentRequisitionAttachment } from '@/models';
import { isURL } from '@/utils/helpers';
import ConfirmationDialog from '../common/ConfirmationDialog.vue';

export default Vue.extend({
  components: { ConfirmationDialog },
  name: 'PaymentRequisitionAttachmentListItem',
  props: {
    attachment: { type: PaymentRequisitionAttachment, required: true },
    fieldError: {
      type: Object as PropType<IFieldErrors>,
      default: (): IFieldErrors => ({})
    }
  },

  data() {
    return {
      fileReader: new FileReader(),
      percentage: 0,
      deleteAttachmentDialog: false
    };
  },

  computed: {
    isLoadingFile(): boolean {
      return this.percentage > 0 && this.percentage < 100;
    }
  },

  mounted() {
    this.addFileListeners();
    this.readasDataURL(this.attachment.file!);
  },

  methods: {
    addFileListeners() {
      this.fileReader.addEventListener('progress', event => {
        if (event.lengthComputable) {
          // we can calculate the percentage
          this.percentage = (event.loaded / event.total) * 100;
        } else if (event.loaded) this.percentage = 100;
      });
    },

    readasDataURL(file: string | File) {
      if (file instanceof File) this.fileReader.readAsDataURL(file);
    },

    getFileName(file: string | File, extension: boolean): string {
      const fileName = typeof file === 'string' ? file : file.name;

      let fileUrlName = fileName;

      if (isURL(fileUrlName)) {
        fileUrlName = decodeURIComponent(
          new URL(fileName).pathname.split('/').pop()!
        );
      }

      if (!fileUrlName) return fileName; // some default fileUrlName

      if (extension) return fileUrlName.split('.').pop()!;

      return fileUrlName;
    },

    removePaymentRequisitionAttachment() {
      if (!this.attachment.id) {
        this.fileReader.abort();
        this.$emit('remove:attachment', this.attachment);
      } else {
        this.deleteAttachmentDialog = true;
      }
    },

    closeAttachmentDialog() {
      this.deleteAttachmentDialog = false;
    },
    confirmAttachmentDialog() {
      this.$emit('remove:attachment', this.attachment);
      this.deleteAttachmentDialog = false;
    },

    roundedPercentage(num: number) {
      return Math.round((num + Number.EPSILON) * 100) / 100;
    },

    getFileType(extension: string) {
      switch (extension) {
        case 'pdf':
          return require('@/assets/icons/pdf-file.svg');

        case 'doc':
        case 'docx':
          return require('@/assets/icons/microsoft-word.svg');

        case 'log':
          return require('@/assets/icons/log-file.svg');

        case 'xml':
          return require('@/assets/icons/xml-file.svg');

        case 'png':
        case 'jpg':
        case 'jpeg':
          return require('@/assets/icons/photo-file.svg');

        default:
          return require('@/assets/icons/document-file.svg');
      }
    }
  }
});
